import {
  Col,
  Form,
  Radio,
  Row,
  Typography,
  Image,
  Input,
  Slider,
  Tag,
  Button,
  DatePicker,
  Spin,
  message,
} from "../../common/utils/antd-imports/AntdImports";
import { useCallback, useEffect, useState } from "react";
import RFPImg from "../../../assests/RFP-Image.png";
import FloatingInput from "../../common/float-input/FloatInput";
import { useSelector } from "react-redux";
import FloatingSelect from "../../common/floating-select/floatingSelect";
import { ReactComponent as BackButton } from "../../../assests/back-arrow.svg";
import "./RfpRequestModal.css";
import dayjs from "dayjs";
import { ReactComponent as CalenderIcon } from "../../../assests/Mobile_calender_Icon.svg";
import {
  getChannelsBeforeLogin,
  postSubmitRFP,
  postSubmitRFPWithLogin,
} from "../../../store/thunks/common-thunks/commonThunk";
import { getChannelsFromProductType } from "../../../store/thunks/seller-thunks/SellerThunk";
import { useDispatch } from "react-redux";
import { PlusOutlined } from "@ant-design/icons";
import { debounce } from "lodash";
import { searchLocation } from "../../../store/thunks/authThunk";
import CalendarComponent from "../../common/calendar/CalendarComponent";
import { ReactComponent as DeleteIcon } from "../../../assests/delete_icon.svg";
import moment from "moment-timezone";
import { PDF_BASE_URL } from "../../../services/common";
import { useNavigate } from "react-router-dom";
import { RESET_RFP } from "../../../store/slices/auth/SubmitRFPSlice";
import {
  allowOnlyAlphabets,
  blockPasteInvalid,
  restrictNumbersAndExponential,
} from "../../common/utils/Utils";
const { Text } = Typography;
const RfpMobileVersion = () => {
  const [selectedProductType, setSelectedProductType] = useState("");
  const { productChannelsList } = useSelector((state) => state.products);
  const [productTypeList, setProductTypeList] = useState([]);
  const [inComeSliderValue, SetInComeSliderValue] = useState([2000, 5000]);
  const [selectedEthnicity, setSelectedEthnicity] = useState("");
  const [selectedTransferProducts, setSelectedTransferProducts] = useState([]);
  const [specificCreative, SetSpecificCreative] = useState("true");
  const [specificMessage, SetSpecificMessage] = useState("true");
  const [callAction, SetCallAction] = useState("true");
  const [productAnimation, SetProductAnimation] = useState("true");
  const [form] = Form.useForm();
  const star = <span style={{ color: "#d2042d" }}>*</span>;
  const [sliderValue, setSliderValue] = useState([2000, 5000]);
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [dmaLocations, setDmaLocations] = useState([]);
  const [dmaList, setDmaList] = useState([
    { id: 1, fromDate: null, toDate: null },
  ]);
  const { locationDma, isLoading: locationLoader } = useSelector(
    (state) => state.location,
  );
  const {
    isLoading: rfpLoader,
    rfpStatus,
    updateSubmitRfpResult,
  } = useSelector((state) => state.submitrfp);
  const isLoading = locationLoader || rfpLoader;
  const [selectedDMALocations, setSelectedDMALocations] = useState({});
  const [searchTerm, setSearchTerm] = useState(""); // Define searchTerm state
  const [selectedDates, SetSelectedDates] = useState("");
  const [dateRanges, setDateRanges] = useState([]);
  const brandGoal = Form.useWatch("brand_goal", form);
  const floatingInputStyles = {
    marginTop: "0px",
    "--input-font-weight": "500",
    "--label-focused-top": "23px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "0.5rem",
  };
  const floatingSelectStyles = {
    marginTop: "0px",
    "--input-font-weight": "500",
    "--label-focused-top": "23px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "0.6rem",
    "--input-padding-top": "1rem",
  };
  const handleIncomeInputChange = (index, e) => {
    let newValue = [...inComeSliderValue];
    newValue[index] = Number(e.target.value) || 0;
    SetInComeSliderValue(newValue);
  };
  const handleInComeSliderChange = (value) => {
    SetInComeSliderValue(value);
  };
  const handleProductTypes = (value) => {
    form.setFieldsValue({ type: null });
    const selectedChannel = productChannelsList?.find(
      (product) => product?.id === value,
    );
    if (selectedChannel) {
      const mapping = {
        Digital: "Digital",
        Digital_Static: "Digital/Static",
        Media: "Media",
        Static: "Static",
      };
      const productTypeList = Object?.entries(mapping)
        ?.filter(([key]) => selectedChannel[key] === 1)
        ?.map(([, label]) => label);
      setProductTypeList(productTypeList);
    }
  };
  const handleInputChange = (index, e) => {
    let newValue = [...sliderValue];
    newValue[index] = Number(e.target.value) || 0; // Convert input to number
    setSliderValue(newValue);
  };
  const handleSliderChange = (value) => {
    setSliderValue(value);
  };
  const disabledDate = (current) => {
    return current && current < dayjs().startOf("day");
  };
  const restrictions = [
    { id: "alcohol", name: "Alcohol-Restricted" },

    {
      id: "adult-content",
      name: "Adult Content Restricted",
    },
    {
      id: "tobacco-smoking",
      name: "Tobacco & Smoking Ads Restricted",
    },
    {
      id: "cannabis-phrma",
      name: "Cannabis/Pharma Restricted",
    },
    {
      id: "gambling-betting",
      name: "Gambling/Betting Restricted",
    },
    {
      id: "religious-content",
      name: "Religious Content Restricted",
    },
    {
      id: "violence-horror-imagery",
      name: "Violence/Horror imagery Restricted",
    },
  ];
  useEffect(() => {
    if (token) {
      dispatch(getChannelsFromProductType({ type: [] }));
    } else {
      dispatch(getChannelsBeforeLogin({ type: [] }));
    }
  }, []);
  const handleAddDma = () => {
    setDmaList([
      ...dmaList,
      { id: dmaList.length + 1, fromDate: null, toDate: null },
    ]);
  };
  const handleDeleteDMA = (id) => {
    setDmaList((prevList) => prevList.filter((dma) => dma.id !== id));
    setSelectedDMALocations((prev) => {
      const updated = { ...prev };
      delete updated[id];
      return updated;
    });
    form.resetFields([`dma-${id}`, "date_ranges"]);
  };
  const handleChange = (value, dmaId) => {
    setSearchTerm(value || "");
    setSelectedDMALocations((prev) => ({
      ...prev,
      [dmaId]: value,
    }));
    form.setFieldValue(`dma-${dmaId}`, value);
  };
  // Debounced search function
  const handleSearch = useCallback(
    debounce((value) => {
      if (!value.trim()) {
        setDmaLocations([]);
        return;
      }

      dispatch(searchLocation(value.trim()));
    }, 300),
    [dispatch],
  );
  // Function to handle date selection for each DMA
  const handleDateRangeChange = (index, dates) => {
    const formattedRange = formatDateRange(index);
    SetSelectedDates(dates);
  };
  const formatDateRange = (dates, index) => {
    if (!Array.isArray(dates) || dates.length !== 2) {
      return;
    }
    const fromDate = new Date(dates[0]).toISOString();
    const toDateObj = new Date(dates[1]);
    toDateObj.setSeconds(toDateObj.getSeconds() - 1); // Adjust end time
    const toDate = toDateObj.toISOString();
    setDateRanges((prevRanges) => {
      const updatedRanges = [...prevRanges]; // Copy previous state
      if (index < updatedRanges.length) {
        updatedRanges[index] = `${fromDate}::${toDate}`;
      } else {
        updatedRanges.push(`${fromDate}::${toDate}`);
      }
      return updatedRanges;
    });
  };
  // Update DMA locations when locationDma changes
  useEffect(() => {
    if (locationDma?.length) {
      const formattedLocations = locationDma?.map((location) => ({
        label: `${location.city_name} - ${location.name}`,
        value: location.id,
        state: location.state_name,
        timeZone: location.area_time_zone_type,
        offSet: location.area_time_zone,
      }));
      setDmaLocations(formattedLocations);
    }
  }, [locationDma]);
  const isTokenValid = () => {
    const token = localStorage.getItem("token");
    if (!token) return false;

    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      return payload.exp * 1000 > Date.now(); // true if token is still valid
    } catch (e) {
      return false;
    }
  };
  const handleSubmit = async (values) => {
    const utmSource = localStorage.getItem("utm_source");
    const dmaKeys = Object.keys(values)?.filter((key) =>
      key.startsWith("dma-"),
    );
    const dmaValues = dmaKeys?.map((key) => values[key]);
    const toArray = (val) => (Array.isArray(val) ? val : [val]);
    const tokenIsValid = isTokenValid();
    const payload = {
      area: dmaValues,
      date_ranges: dateRanges, // Dynamic multiple date ranges
      due_date: new Date().toISOString(),
      first_name: values.first_name,
      last_name: values.last_name,
      user_email: values.user_email,
      mobile_no: values.mobile_no,
      producttype: toArray(values.producttype),
      campaign_name: values.campaign_name,
      demo: values.demo,
      instructions: values.instructions || "Test",
      est_budget_from: sliderValue[0]?.toString(),
      est_budget_to: sliderValue[1]?.toString(),
      budget: sliderValue[1]?.toString(),
      brand_goal: toArray(
        values.brand_goal === "Others"
          ? values.brand_goal_other
          : values.brand_goal,
      ),
      business_goal: toArray(values.business_goal),
      format_type: toArray(values.format_type),
      desired_medium: toArray(values.desiredMedium),
      target_consumer: values.targetConsumer,
      age: values.age,
      marketing_funnel: toArray[values.marketing_funnel],
      income_from: inComeSliderValue[0]?.toString(),
      income_to: inComeSliderValue[1]?.toString(),
      ethnicity: toArray(
        values.ethnicity === "other" && values.others
          ? values.others
          : values.ethnicity,
      ),
      restrictions: toArray(selectedTransferProducts),
      creative_to_run: specificCreative,
      specific_message: specificMessage,
      call_to_action: callAction,
      product_animation: productAnimation,
      ...(utmSource && {
        utm_source: utmSource,
      }),
    };

    if (!tokenIsValid) {
      payload.first_name = values.first_name;
      payload.last_name = values.last_name;
      payload.user_email = values.user_email;
      payload.mobile_no = values.mobile_no;
    }
    tokenIsValid
      ? dispatch(postSubmitRFPWithLogin(payload))
      : dispatch(postSubmitRFP(payload));
  };
  useEffect(() => {
    if (rfpStatus === "success") {
      if (updateSubmitRfpResult) {
        message.success(updateSubmitRfpResult);
        form.resetFields();
        SetInComeSliderValue([5000, 40000]);
        setSliderValue([5000, 40000]);
        setDmaList([{ id: 1 }]);
        setSelectedDMALocations({});
        setDateRanges({});
        setSearchTerm("");
        setSelectedTransferProducts([]);
        SetSpecificCreative("true");
        SetSpecificMessage("true");
        SetCallAction("true");
        SetProductAnimation("true");
        navigate(-1);
        dispatch(RESET_RFP());
      }
    } else if (rfpStatus === "failed") {
      dispatch(RESET_RFP());
    }
  }, [rfpStatus]);
  const isSubmitDisabled = () => {
    const hasErrors = form.getFieldsError().some(({ errors }) => errors.length);
    const commonRequiredFields = [
      "campaign_name",
      "format_type",
      "producttype",
      "age",
      "marketing_funnel",
      "due_date",
      ...dmaList?.map((dma) => `dma-${dma?.id}`),
    ];

    const requiredFields = isTokenValid()
      ? commonRequiredFields
      : [
          "first_name",
          "last_name",
          "user_email",
          "mobile_no",
          ...commonRequiredFields,
        ];

    return (
      hasErrors ||
      requiredFields?.some((field) => {
        const value = form?.getFieldValue(field);

        return (
          value === undefined ||
          value === null ||
          value === "" ||
          (Array?.isArray(value) && value?.length === 0)
        );
      })
    );
  };
  return (
    <>
      <div>
        <Form onFinish={handleSubmit} form={form}>
          <div className="rfp-version-main-div">
            <Row className="rfp-version-main-div-row" gutter={[16, 16]}>
              <Col style={{ paddingLeft: "0px", paddingRight: "0px" }}>
                <BackButton
                  size="small"
                  className="back-button-rfp-version"
                  onClick={() => navigate(-1)}
                />
              </Col>
              <Col>
                <Text className="submit-an-rfp-version-text">
                  Submit Your RFP
                </Text>
              </Col>
            </Row>
            <Col className="image-container-version">
              <div className="images-rfp-main">
                <Image
                  src={RFPImg}
                  preview={false}
                  alt="RFP-form-img"
                  style={{ borderRadius: "8px" }}
                />
              </div>
            </Col>

            {!isTokenValid() ? (
              <>
                <Row style={{ marginTop: "15px", marginBottom: "10px" }}>
                  <Text className="common-text-for-all">CUSTOMER</Text>
                </Row>
                <Row className="under-title-row">
                  <Form.Item
                    name="first_name"
                    rules={[
                      {
                        required: true,
                        message: "Please input your First Name",
                      },
                    ]}
                    style={{ width: "100%" }}
                  >
                    <FloatingInput
                      className="billboard-input-feild"
                      label={
                        <>
                          {`First Name `}
                          {star}
                        </>
                      }
                      onKeyDown={restrictNumbersAndExponential}
                      onChange={allowOnlyAlphabets}
                      onPaste={blockPasteInvalid}
                      customStyles={floatingInputStyles}
                    />
                  </Form.Item>
                </Row>
                <Row>
                  <Form.Item
                    name="last_name"
                    rules={[
                      {
                        required: true,
                        message: "Please input your Last Name",
                      },
                    ]}
                    style={{ width: "100%" }}
                  >
                    <FloatingInput
                      className="billboard-input-feild"
                      label={
                        <>
                          {`Last Name `}
                          {star}
                        </>
                      }
                      onKeyDown={restrictNumbersAndExponential}
                      onChange={allowOnlyAlphabets}
                      onPaste={blockPasteInvalid}
                      customStyles={floatingInputStyles}
                    />
                  </Form.Item>
                </Row>
                <Row>
                  <Form.Item
                    name="campaign_name"
                    rules={[
                      {
                        required: true,
                        message: "Please input your Campaign Name",
                      },
                    ]}
                    style={{ width: "100%" }}
                  >
                    <FloatingInput
                      className="billboard-input-feild"
                      label={
                        <>
                          {`Campaign Name `}
                          {star}
                        </>
                      }
                      customStyles={floatingInputStyles}
                    />
                  </Form.Item>
                </Row>
                <Row>
                  <Form.Item
                    name="user_email"
                    rules={[
                      {
                        type: "email",
                        required: true,
                        message: "Please input your Email",
                      },
                    ]}
                    style={{ width: "100%" }}
                  >
                    <FloatingInput
                      className="billboard-input-feild"
                      label={
                        <>
                          {`Email `}
                          {star}
                        </>
                      }
                      customStyles={floatingInputStyles}
                    />
                  </Form.Item>
                </Row>
                <Row>
                  <Form.Item
                    name="mobile_no"
                    rules={[
                      {
                        required: true,
                        message: "Please input your Phone Number",
                      },
                      {
                        pattern: /^\d{10}$/,
                        message: "Phone number must be exactly 10 digits",
                      },
                    ]}
                    style={{ width: "100%" }}
                  >
                    <FloatingInput
                      className="billboard-input-feild"
                      label={
                        <>
                          {`Phone Number `}
                          {star}
                        </>
                      }
                      maxLength={10}
                      onKeyPress={(e) => {
                        if (!/^\d$/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      customStyles={floatingInputStyles}
                    />
                  </Form.Item>
                </Row>
              </>
            ) : (
              <>
                <Row style={{ marginTop: "15px" }}>
                  <Text className="common-text-for-all">CAMPAIGN DETAILS</Text>
                </Row>
                <Row style={{ marginTop: "10px" }}>
                  <Form.Item
                    name="campaign_name"
                    rules={[
                      {
                        required: true,
                        message: "Please input your Campaign Name",
                      },
                    ]}
                    style={{ width: "100%" }}
                  >
                    <FloatingInput
                      className="billboard-input-feild"
                      label={
                        <>
                          {`Campaign Name `}
                          {star}
                        </>
                      }
                      customStyles={floatingInputStyles}
                    />
                  </Form.Item>
                </Row>
              </>
            )}
            <Row style={{ marginBottom: "10px" }}>
              <Text className="common-text-for-all">
                BUSINESS & MARKETING GOALS
              </Text>
            </Row>
            <Row>
              <Form.Item
                name="brand_goal"
                rules={[
                  {
                    required: true,
                    message: "Please select a brand goal!",
                  },
                ]}
                style={{ width: "100%" }}
              >
                <FloatingSelect
                  className="billboard-select-feild"
                  border={false}
                  label={
                    <>
                      {`Brand Goal `}
                      {star}
                    </>
                  }
                  options={[
                    {
                      id: "brand-exposure",
                      name: "Brand Exposure",
                    },
                    {
                      id: "sample/trial-product",
                      name: "Sample/trial Product",
                    },
                    {
                      id: "generate-leads",
                      name: "Generate Leads",
                    },
                    {
                      id: "social-media-following",
                      name: "Increase Social media following",
                    },
                    {
                      id: "kpit-measurement",
                      name: "KPI Measurements",
                    },
                    {
                      id: "others",
                      name: "Others",
                    },
                  ]}
                  customStyles={floatingSelectStyles}
                  onChange={(value) => {
                    if (value !== "Others") {
                      form.setFieldsValue({ brand_goal_other: undefined });
                    }
                  }}
                />
              </Form.Item>
            </Row>
            {brandGoal === "Others" && (
              <Row>
                <Form.Item
                  name="brand_goal_other"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Brand Goal",
                    },
                  ]}
                  style={{ width: "100%" }}
                >
                  <FloatingInput
                    className="billboard-input-feild"
                    label={
                      <>
                        {`Brand Goal - Others `}
                        {star}
                      </>
                    }
                    customStyles={floatingInputStyles}
                  />
                </Form.Item>
              </Row>
            )}
            <Row>
              <Form.Item
                name="business_goal"
                rules={[
                  {
                    required: true,
                    message: "Please select business/commercial goals!",
                  },
                ]}
                style={{ width: "100%" }}
              >
                <FloatingSelect
                  className="billboard-select-feild"
                  border={false}
                  label={
                    <>
                      {`Business/Commercial Goals`}
                      {star}
                    </>
                  }
                  options={[
                    {
                      id: "rfp-input-field",
                      name: "More Subscribers",
                    },
                    {
                      id: "buy-new-product-at-retail",
                      name: "Buy new product at retail",
                    },
                    {
                      id: "convert-store-shopper-to-home-subscription-model",
                      name: "Convert store shopper to home subscription model",
                    },
                  ]}
                  customStyles={floatingSelectStyles}
                />
              </Form.Item>
            </Row>
            <Row style={{ marginBottom: "10px" }}>
              <Text className="common-text-for-all">TIMING & LOCATION</Text>
            </Row>
            <Row>
              <Form.Item
                name="format_type"
                rules={[
                  {
                    required: true,
                    message: "Please select a product type!",
                  },
                ]}
                style={{ width: "100%" }}
              >
                <FloatingSelect
                  className="billboard-select-feild"
                  border={false}
                  label={
                    <>
                      {`Product Type`}
                      {star}
                    </>
                  }
                  value={selectedProductType}
                  isChannels={true}
                  options={productChannelsList.map((channel) => ({
                    id: channel.id,
                    name: `${channel.channel_name} - ${channel.sub_channel_name}`,
                  }))}
                  onChange={(_e, value) => {
                    setSelectedProductType(value?.value || null);
                    handleProductTypes(value?.value);
                  }}
                  customStyles={floatingSelectStyles}
                />
              </Form.Item>
            </Row>
            <Row>
              <Form.Item
                name="producttype"
                rules={[
                  {
                    required: true,
                    message: "Please select a business and format type!",
                  },
                ]}
                style={{ width: "100%" }}
              >
                <FloatingSelect
                  className="billboard-select-feild"
                  border={false}
                  label={
                    <>
                      {`Format`}
                      {star}
                    </>
                  }
                  options={productTypeList?.map((type, index) => ({
                    id: index,
                    name: type,
                  }))}
                  customStyles={floatingSelectStyles}
                  disabled={!selectedProductType}
                  onChange={(_e, value) => {
                    setSelectedProductType(value?.key);
                  }}
                />
              </Form.Item>
            </Row>
            <Row gutter={[16, 16]}>
              <Row className="dma-rfp-version-row">
                {dmaList?.map((dma, index) => {
                  const isDMALocationSelected = Boolean(
                    dmaLocations?.find((loc) => loc?.value === searchTerm),
                  );

                  return (
                    <Row key={dma.id} className="dma-selected">
                      <Col style={{ width: "48%" }}>
                        <span>{isDMALocationSelected}</span>
                        <Form.Item
                          name={`dma-${dma.id}`}
                          className="billboard-select-form-item"
                        >
                          <FloatingSelect
                            showSearch
                            allowClear
                            className="billboard-select-feild"
                            label={
                              <>
                                {`DMA `}
                                {star}
                              </>
                            }
                            value={
                              searchTerm || selectedDMALocations[dma.id] || ""
                            }
                            onChange={(value) => handleChange(value, dma.id)}
                            onSearch={handleSearch} // Debounced API call
                            loading={isLoading} // Show spinner if request is in progress
                            options={dmaLocations}
                            isDma={true}
                            optionFilterProp="label"
                            filterSort={(optionA, optionB) =>
                              (optionA?.label ?? "")
                                .toLowerCase()
                                .localeCompare(
                                  (optionB?.label ?? "").toLowerCase(),
                                )
                            }
                            customStyles={floatingSelectStyles}
                          />
                        </Form.Item>
                      </Col>
                      <Col
                        style={{
                          width: index !== 0 ? "40%" : "48%",
                          justifyContent: "space-between",
                        }}
                        className={` ${
                          !form?.getFieldValue(`dma-${dma?.id}`)
                            ? "disabled-opacity"
                            : ""
                        }`}
                      >
                        <Form.Item
                          className="rfp-input-field"
                          name="date_ranges"
                          style={{ paddingTop: 20 }}
                        >
                          <div className="rfp-dma-calendar-div">
                            <CalendarComponent
                              className="rfp-dma-calendar"
                              disabled={
                                !searchTerm?.length ||
                                !selectedDMALocations[dma.id]
                              }
                              onDateRangeChange={handleDateRangeChange}
                              disabledDate={(current) => {
                                const dma = dmaLocations?.find(
                                  (location) =>
                                    location.value ===
                                    form.getFieldValue(`dma-${dma.id}`),
                                );
                                const nowUTC = moment().utc();
                                const nowInSelectedTZ = nowUTC
                                  .tz(dma?.timeZone)
                                  ?.startOf("day");
                                return (
                                  current &&
                                  current?.isBefore(nowInSelectedTZ, "day")
                                );
                              }}
                            />
                          </div>
                        </Form.Item>
                      </Col>
                      {index !== 0 && (
                        <Col style={{ width: "5%" }}>
                          <DeleteIcon
                            style={{ color: "#d2042d" }}
                            onClick={() => handleDeleteDMA(dma.id)}
                            className="version-rfp-delete-icon"
                          />
                        </Col>
                      )}
                    </Row>
                  );
                })}
              </Row>
              <Col span={12}>
                <a
                  href={`${PDF_BASE_URL}/DMA%20-%20PDF.pdf`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: "#d2042d",
                    textDecoration: "underline",
                  }}
                  className="view-add-dma-version"
                >
                  View DMA Map (PDF)
                </a>
              </Col>

              <Col span={12}>
                <div className="handle-dma-rfp-version-add-new">
                  <Button
                    className="handle-dma-rfp-version-add-new-btn"
                    onClick={handleAddDma}
                  >
                    <PlusOutlined />
                    Add New DMA
                  </Button>
                </div>
              </Col>
            </Row>
            <Row className="budget-version-rfp">
              <Text className="common-text-for-all">BUDGET</Text>
            </Row>
            <Row className="budget-input" gutter={[16, 16]}>
              <Col span={12}>
                <Form.Item name="est_budget_from">
                  <Row>
                    <span className="rfp-to-input">From</span>
                  </Row>
                  <Row>
                    <Input
                      className="rfp-input-field"
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      inputMode="decimal"
                      pattern="[0-9]*"
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      value={sliderValue[0]}
                      onChange={(e) => handleInputChange(0, e)}
                      variant="underlined"
                      prefix="$"
                    />
                  </Row>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="est_budget_to">
                  <Row>
                    <span className="rfp-to-input">To</span>
                  </Row>
                  <Row>
                    <Input
                      className="rfp-input-field"
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      inputMode="decimal"
                      pattern="[0-9]*"
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      value={sliderValue[1]}
                      onChange={(e) => handleInputChange(1, e)}
                      variant="underlined"
                      prefix="$"
                    />
                  </Row>
                </Form.Item>
              </Col>
            </Row>
            <div className="slider-parent">
              <Slider
                range
                value={sliderValue}
                min={0}
                max={500000}
                trackStyle={{ backgroundColor: "red" }}
                tooltip={{ open: false }}
                onChange={handleSliderChange}
              />
            </div>
            <Row className="target-demeographics-rfp-version">
              <Text className="common-text-for-all">TARGET & DEMOGRAPHICS</Text>
            </Row>
            <Row>
              <Form.Item
                name="age"
                rules={[
                  {
                    required: true,
                    message: "Please select a age!",
                  },
                ]}
                style={{ width: "100%" }}
              >
                <FloatingSelect
                  className="billboard-select-feild"
                  border={false}
                  label={
                    <>
                      {`Age`}
                      {star}
                    </>
                  }
                  options={[
                    { id: "18-49", name: "18-49" },

                    {
                      id: "cmpa- 18-plus",
                      name: "CPM A 18-49",
                    },
                    {
                      id: "18-plus",
                      name: "18-Plus",
                    },
                    {
                      id: "cpma-18-plus",
                      name: "CPM A 18-Plus",
                    },
                    {
                      id: "25-54",
                      name: "25-54",
                    },
                    {
                      id: "cpma-25-54",
                      name: "CPM A 25-54",
                    },
                  ]}
                  customStyles={floatingSelectStyles}
                />
              </Form.Item>
            </Row>
            <Row>
              <Form.Item
                name="marketing_funnel"
                rules={[
                  {
                    required: true,
                    message: "Please select marketing-funnels!",
                  },
                ]}
                style={{ width: "100%" }}
              >
                <FloatingSelect
                  className="billboard-select-feild"
                  border={false}
                  label={
                    <>
                      {`Marketing Funnel`}
                      {star}
                    </>
                  }
                  options={[
                    { id: "awareness", name: "Awareness" },

                    {
                      id: "interest",
                      name: "Interest",
                    },
                    {
                      id: "consideration",
                      name: "Consideration",
                    },
                    {
                      id: "intent",
                      name: "Intent",
                    },
                    {
                      id: "evaluation",
                      name: "Evaluation",
                    },
                    {
                      id: "purchase",
                      name: "Purchase",
                    },
                    {
                      id: "post-purchase-loyalty",
                      name: "Post-Purchase / Loyalty",
                    },
                  ]}
                  customStyles={floatingSelectStyles}
                />
              </Form.Item>
            </Row>
            <Row>
              <Text className="rfp-budget-range-text">Income Range</Text>
            </Row>
            <Row className="budget-input" gutter={[16, 16]}>
              <Col span={12}>
                <Form.Item name="income_from">
                  <Row>
                    <span className="rfp-to-input">From</span>
                  </Row>
                  <Row>
                    <Input
                      className="rfp-input-field"
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      inputMode="decimal"
                      pattern="[0-9]*"
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      value={inComeSliderValue[0]}
                      onChange={(e) => handleIncomeInputChange(0, e)}
                      variant="underlined"
                      prefix="$"
                    />
                  </Row>
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item name="income_to">
                  <Row>
                    <span className="rfp-to-input">To</span>
                  </Row>
                  <Row>
                    <Input
                      className="rfp-input-field"
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      inputMode="decimal"
                      pattern="[0-9]*"
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      value={inComeSliderValue[1]}
                      onChange={(e) => handleIncomeInputChange(1, e)}
                      variant="underlined"
                      prefix="$"
                    />
                  </Row>
                </Form.Item>
              </Col>
            </Row>
            <div className="slider-parent">
              <Slider
                range
                value={inComeSliderValue}
                min={0}
                max={500000}
                trackStyle={{ backgroundColor: "red" }}
                tooltip={{ open: false }}
                onChange={handleInComeSliderChange}
              />
            </div>
            <Row>
              <Form.Item
                name="ethnicity"
                rules={[
                  {
                    required: true,
                    message: "Please select a brand ethnicity!",
                  },
                ]}
                style={{ width: "100%" }}
              >
                <FloatingSelect
                  className="billboard-select-feild"
                  border={false}
                  label={
                    <>
                      {`Ethnicity`}
                      {star}
                    </>
                  }
                  options={[
                    { id: "caucasian", name: "Caucasian" },

                    {
                      id: "hispanic",
                      name: "Hispanic",
                    },
                    {
                      id: "af-american",
                      name: "Af American/Digital",
                    },
                    {
                      id: "Asian",
                      name: "Asian",
                    },
                    { id: "native-am", name: "Native Am " },
                    { id: "other", name: "Other" },
                  ]}
                  onChange={(value) => {
                    setSelectedEthnicity(value);
                  }}
                  value={selectedEthnicity}
                  customStyles={floatingSelectStyles}
                />
              </Form.Item>
            </Row>
            <Row>
              {selectedEthnicity === "Other" && (
                <Form.Item
                  name="others"
                  rules={[
                    {
                      type: "ethnicity-other",
                      required: true,
                      message: "Please input your ehtnicity",
                    },
                  ]}
                >
                  <FloatingInput
                    className="billboard-input-feild"
                    label={
                      <>
                        {`Others (Specify)`}
                        {star}
                      </>
                    }
                    customStyles={floatingInputStyles}
                  />
                </Form.Item>
              )}
            </Row>
            <Row>
              <Text className="common-text-for-all">RESTRICTIONS</Text>
            </Row>
            <Row gutter={[16, 16]} style={{ marginTop: "1rem" }}>
              <Form.Item
                name="restrictions"
                rules={[
                  {
                    required: true,
                    message: "Please select the restrictions!",
                  },
                ]}
                style={{ width: "100%" }}
              >
                <div className="restrictions-col">
                  <FloatingSelect
                    value={selectedTransferProducts}
                    mode="multiple"
                    className="billboard-select-feild transfer-product"
                    border={false}
                    isMultipleProduct={true}
                    label={
                      <>
                        {`Restrictions`}
                        {star}
                      </>
                    }
                    options={restrictions}
                    onChange={(_e, values) => {
                      const selectedValues = values?.map((item) => item.value);
                      setSelectedTransferProducts(selectedValues);
                    }}
                    popupClassName="transfer-product"
                    customStyles={floatingSelectStyles}
                    tagRender={() => <></>}
                  />
                </div>
              </Form.Item>
            </Row>
            <div className="selected-vals">
              {selectedTransferProducts &&
                selectedTransferProducts.length > 0 &&
                selectedTransferProducts?.map((transferProduct) => (
                  <Tag
                    key={transferProduct}
                    className="transfer-product-chip"
                    closable
                    onClose={(e) => {
                      e.preventDefault();
                      setSelectedTransferProducts(
                        selectedTransferProducts.filter(
                          (chip) => chip !== transferProduct,
                        ),
                      );
                    }}
                  >
                    <span>
                      {
                        restrictions?.find(
                          (product) => product?.id === transferProduct,
                        )?.name
                      }
                    </span>
                  </Tag>
                ))}
            </div>
            <Row>
              <Text className="common-text-for-all">OTHER INSTRUCTIONS</Text>
            </Row>
            <Row className="radio-btn-rfp-version">
              <Text className="rfp-other-instructions-text">
                Do you have specific creative to run?
              </Text>
            </Row>
            <Row gutter={[16, 16]} className="radio-btn-rfp-version">
              <Col>
                <Radio.Group
                  onChange={(e) => {
                    SetSpecificCreative(e.target.value);
                  }}
                  value={specificCreative}
                >
                  <Radio value={"true"}>Yes</Radio>
                  <Radio value={"false"}>No</Radio>
                </Radio.Group>
              </Col>
            </Row>
            <Row style={{ marginTop: "10px" }}>
              <Text className="rfp-other-instructions-text">
                Specific Message
              </Text>
            </Row>
            <Row>
              <Col style={{ marginTop: "10px" }}>
                <Radio.Group
                  onChange={(e) => {
                    SetSpecificMessage(e.target.value);
                  }}
                  value={specificMessage}
                >
                  <Radio value={"true"}>Yes</Radio>
                  <Radio value={"false"}>No</Radio>
                </Radio.Group>
              </Col>
            </Row>
            <Row style={{ marginTop: "10px" }}>
              <Text className="rfp-other-instructions-text">
                Call to Action
              </Text>
            </Row>
            <Row>
              <Col className="radio-btn-rfp-version">
                <Radio.Group
                  onChange={(e) => {
                    SetCallAction(e.target.value);
                  }}
                  value={callAction}
                >
                  <Radio value={"true"}>Yes</Radio>
                  <Radio value={"false"}>No</Radio>
                </Radio.Group>
              </Col>
            </Row>
            <Row className="radio-btn-rfp-version">
              <Text className="rfp-other-instructions-text">
                Product Animation
              </Text>
            </Row>
            <Row>
              <Col className="radio-btn-rfp-version">
                <Radio.Group
                  onChange={(e) => {
                    SetProductAnimation(e.target.value);
                  }}
                  value={productAnimation}
                >
                  <Radio value={"true"}>Yes</Radio>
                  <Radio value={"false"}>No</Radio>
                </Radio.Group>
              </Col>
            </Row>
            <Row className="due-date-rfp-version">
              <Text className="common-text-for-all">Due Date</Text>
            </Row>
            <Row className="rfp-due-date-version-row">
              <Form.Item
                name="due_date"
                rules={[
                  {
                    required: true,
                    message: "Please select the end date",
                  },
                ]}
                className="rfp-due-date-version-form-item"
              >
                <DatePicker
                  placeholder={"Due Date"}
                  className="billboard-datepicker"
                  suffixIcon={<CalenderIcon />}
                  disabledDate={disabledDate}
                  superNextIcon={false}
                  superPrevIcon={false}
                  popupClassName="end-date-calendar"
                />
              </Form.Item>
            </Row>

            <Row gutter={[16, 16]} className="rfp-submit-btn-version-row">
              <Button
                type="primary"
                htmlType="submit"
                style={{
                  width: "100%",
                }}
                className={`rfp-submit-btn-version ${
                  isSubmitDisabled() ? "disabled-opacity" : ""
                }`}
                id="submit_an_rfp_btn"
                disabled={isSubmitDisabled()}
              >
                <Text className="rfp-submit-btn-version-text">Submit RFP</Text>
              </Button>
            </Row>
          </div>
        </Form>
      </div>
      {isLoading && (
        <div className="rfp-version-spin">
          <Spin size="large" fullscreen />
        </div>
      )}
    </>
  );
};
export default RfpMobileVersion;
